import { render } from "./TheUserAntifrodeDetail.vue?vue&type=template&id=2a9d5e2a"
import script from "./TheUserAntifrodeDetail.vue?vue&type=script&lang=js"
export * from "./TheUserAntifrodeDetail.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__